import React from 'react'
import '../Common.scss'
import defaultImage from '../../../assets/default.png';

function FalseCeilingElectricalLoopingView({pageDetails}) {
    const {images}=pageDetails
    return (
        <React.Fragment>
        <div className="page-heading">{pageDetails?.name}</div>
        {
        images && images.map((image)=>{
            return<React.Fragment>
                <div className="page-image-container" style={{height:"100%"}}>
                    <div className="image-section-container" >
                        <div>
                            <img crossOrigin="anonymous"  src={image ? image?.imageUrl : defaultImage } alt="" className="image-view" style={{marginTop:"10px"}}/>
                        </div>
                    </div>
                </div>
                </React.Fragment>
        })
        }
        </React.Fragment>
    )
}

export default FalseCeilingElectricalLoopingView